import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { ChatbotWidget } from '../components/public/ChatbotWidget';
import { PostJobFloatingButton } from '../components/public/PostJobFloatingButton';
import { PublicFooter } from '../components/public/PublicFooter';
import { PublicHeader } from '../components/public/PublicHeader';
import { WhatsAppFloatingButton } from '../components/public/WhatsAppFloatingButton';

export const PublicLayout = () => {
  const location = useLocation();
  // Scroll to top on every public route change so transitions land at the hero.
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior }); }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-900">
      <PublicHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
      <WhatsAppFloatingButton />
      <PostJobFloatingButton />
      <ChatbotWidget />
    </div>
  );
};
